import { COMMON_URL } from '../../CONSTANTS'
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from 'axios'
import Cookies from 'universal-cookie';

const cook = new Cookies().get('loginData1')


const headersdata = {
    'content-type': 'application/json',
    'Accept': 'application/json',
    get Authorization() {
        const cook = new Cookies().get('loginData1');
        return cook != undefined ? cook.accessToken : '';
    }
}
export const getTransactionTypeKeyValueList = () => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(COMMON_URL() + "getTransactionTypeKeyValueList", { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemDetail axios!");
                });
        } catch (error) {
            console.error("in LoginService > getItemDetail, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};
export const getTransactionStatusKeyValueListByType = (type) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .get(COMMON_URL() + "getTransactionStatusKeyValueListByType/" + type, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in getItemDetail axios!");
                });
        } catch (error) {
            console.error("in LoginService > getItemDetail, Err===", error);
            reject(SYSTEM_ERROR);
        }
    });
};